var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingElynkerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 16,
    viewBox: "0 0 55 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87374 12.5895C1.9423 12.5895 0 10.6831 0 7.8416C0 5.00008 1.9423 3.09375 4.87374 3.09375C7.80518 3.09375 9.74748 5.00008 9.74748 7.8416V8.25524L9.56764 8.43508H2.19408C2.39191 9.85584 3.47097 10.791 4.87374 10.791C5.93481 10.791 6.92395 10.1796 7.33759 9.28034H9.53167C8.93819 11.2586 7.06782 12.5895 4.87374 12.5895ZM2.33796 6.63665H7.40952C6.99589 5.52163 6.07869 4.89218 4.87374 4.89218C3.66879 4.89218 2.7516 5.52163 2.33796 6.63665Z",
    fill: "#1843A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1042 12.5895C39.1728 12.5895 37.2305 10.6831 37.2305 7.8416C37.2305 5.00008 39.1728 3.09375 42.1042 3.09375C45.0356 3.09375 46.978 5.00008 46.978 7.8416V8.25524L46.7981 8.43508H39.4246C39.6224 9.85584 40.7014 10.791 42.1042 10.791C43.1653 10.791 44.1544 10.1796 44.5681 9.28034H46.7621C46.1687 11.2586 44.2983 12.5895 42.1042 12.5895ZM39.5684 6.63665H44.64C44.2264 5.52163 43.3092 4.89218 42.1042 4.89218C40.8993 4.89218 39.9821 5.52163 39.5684 6.63665Z",
    fill: "#1843A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.409 3.58496H48.2793V12.4982H50.409V3.58496Z",
    fill: "#1843A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0869 12.3372V0H13.245V12.3372H11.0869Z",
    fill: "#1843A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4316 5.63255C53.0433 4.81222 53.1695 4.02869 53.4061 3.73947C52.081 3.86567 50.8557 5.15928 50.4088 5.79031V7.60451C51.3553 5.52212 53.0118 5.79031 53.7217 6.1847C53.9741 5.99539 54.3001 5.73772 54.4316 5.63255Z",
    fill: "#1843A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5981 12.3372V0H30.7563V6.4024L33.7956 3.34508H36.817L33.0043 7.08581L37.2486 12.3372H34.479L31.4576 8.59649L30.7563 9.29787V12.3372H28.5981Z",
    fill: "#1843A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8566 16.0003L17.4033 12.0797L13.9683 3.66309H16.2703L18.5003 9.31015L20.7124 3.66309H23.0323L18.1766 16.0003H15.8566Z",
    fill: "#864FFD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8818 5.66636C22.2111 5.5001 22.607 5.40971 23.0523 5.40971C24.3742 5.40971 25.2615 6.20648 25.2615 7.41973V12.7979H27.4345V7.16621C27.4345 4.957 25.7866 3.49023 23.3058 3.49023C22.7849 3.49023 22.2329 3.61503 21.7448 3.83167L21.8818 5.66636Z",
    fill: "#864FFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5906 3.50601C22.1392 3.44291 21.0928 3.58489 20.751 3.66377C20.9613 3.84782 21.3978 4.21592 21.4609 4.21592C21.524 4.21592 22.7492 4.05816 23.354 3.97928L23.5906 3.50601Z",
    fill: "#864FFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingElynkerLogo);
export default __webpack_public_path__ + "static/media/landing-elynker-logo.ef57cb27be63ef7f6229749dbde905de.svg";
export { ForwardRef as ReactComponent };